import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { CredusText, color } from 'ui';

import { TitleDivProps } from '../candidate-upload/components/Index';
import ReportData from './ReportData';

const Report = () => {
  const navigate = useNavigate();

  const title = [
    {
      name: 'Candidates',
      active: false,
      route: '/test-management/candidate-upload',
    },
    { name: 'Test', active: false, route: '/test-management/test-upload' },
    { name: 'Report', active: true, route: '/test-management/report' },
  ];
  return (
    <div>
      <TabDiv>
        <Div>
          {title.map((el) => (
            <TitleDiv active={el.active} onClick={() => navigate(el.route)}>
              <CredusText
                size="md"
                weight="bold"
                color={el.active ? color.primary : ''}
              >
                {el?.name}
              </CredusText>
            </TitleDiv>
          ))}
        </Div>
      </TabDiv>

      <ReportData />
    </div>
  );
};

export default Report;

const TabDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 7rem;
`;

const Div = styled.div`
  display: flex;
  gap: 2rem;
`;

const TitleDiv = styled.div<TitleDivProps>`
  padding: 2px;
  padding-bottom: 1rem;
  cursor: pointer;
  border-bottom: ${({ active }) =>
    active ? '3px solid' + color.primary : 'none'};
`;
